exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.title[data-v-26084dc2]{\n  margin-top: 0.96rem;\n  font-size: 0.44rem;\n  font-family: DMSans-Bold, DMSans;\n  font-weight: bold;\n  color: #1F1F1F;\n  line-height: 0.58rem;\n}\n.des[data-v-26084dc2]{\n  font-size: 0.24rem;\n  font-family: DMSans-Regular, DMSans;\n  font-weight: 400;\n  color: #4C4C4C;\n  line-height: 0.32rem;\n}\n.des span[data-v-26084dc2]{\n  font-weight: bold;\n}\n\n", ""]);

// exports
